import React from 'react';

const AppFooter = () => {
    return (
        <div className="layout-footer ">
            <div className="footer-logo-container">
                {/* <img id="footer-logo" src="./macademy-logo2.jpg" alt="diamond-layout" /> */}
                {/* <img id="footer-logo" src="https://classetimage.s3.ap-south-1.amazonaws.com/" alt="diamond-layout" /> */}
                <span className="app-name">Powered by ©CLASSET</span>
                {/* <span className="app-name">Powered by   </span> <img width="100vw" id="footer-logo" src="https://classet-profiles-old.s3.ap-south-1.amazonaws.com/uploads/17358829538761712311939159IMG-20231127-WA0017%20-%20Copy.jpg" alt="diamond-layout" />  */}
            </div>
            <span className="copyright">&#169; - 2025</span>
        </div>
    );
};

export default AppFooter;